import React from 'react';
import { Button } from "react-bootstrap";
import { CloudSlash } from 'react-bootstrap-icons';

import { withRouter } from "react-router-dom";

class ServerErrorComponent extends React.Component {
  handleClickLink = (href) => {
    this.props.history.push(href);
  }

  render() {
      return (
        <div className="mt-4 text-center">
          <CloudSlash size={64} className="mr-1 text-danger" />
          <div className="mt-2">{this.props.label ? this.props.label : "Internal Server Error (500)"}</div>
          {/*<div className="mt-4"><Button variant="link" onClick={() => this.handleClickLink("/")}>Go to login page</Button></div>*/}
        </div>
      );
  }
}

export default withRouter(ServerErrorComponent);